export default "__VITE_ASSET__DZJE4Nzf__"